import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = ["href", "textContent"]
const _hoisted_3 = {
  key: 1,
  textContent: 'N/A'
}
const _hoisted_4 = ["textContent"]
const _hoisted_5 = {
  key: 1,
  textContent: 'N/A'
}

import { formatPhone } from '@/composables';
import { PersonStores } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'StudentReferrals',
  setup(__props) {

const profileStore = PersonStores.useUserProfileStore();

return (_ctx: any,_cache: any) => {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "p-fluid" }, {
    header: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("h2", null, "Referrals", -1)
    ]))]),
    content: _withCtx(() => [
      _createVNode(_component_DataTable, {
        value: _unref(profileStore).person.student_referrals,
        scrollable: true,
        "loading-icon": "logo-spinner",
        loading: _unref(profileStore).loading,
        "responsive-layout": "scroll",
        "scroll-height": "440px"
      }, {
        empty: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("There are no referrals for this student", -1)
        ]))]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "referral_type",
            header: "Referral Type"
          }),
          _createVNode(_component_Column, {
            field: "referrer_title",
            header: "Title/Relationship"
          }),
          _createVNode(_component_Column, { header: "Referred By" }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("span", {
                textContent: _toDisplayString(`${data.referrer_first_name} ${data.referrer_last_name}`)
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Email" }, {
            body: _withCtx(({ data }) => [
              (data.referrer_email)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: `mailto:${data.referrer_email}`,
                    textContent: _toDisplayString(data.referrer_email)
                  }, null, 8, _hoisted_2))
                : (_openBlock(), _createElementBlock("span", _hoisted_3))
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Phone" }, {
            body: _withCtx(({ data }) => [
              (data.referrer_phone)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    textContent: _toDisplayString(_unref(formatPhone)(data.referrer_phone))
                  }, null, 8, _hoisted_4))
                : (_openBlock(), _createElementBlock("span", _hoisted_5))
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "referral_referred_at",
            header: "Date of Referral",
            "header-class": "justify-content-center",
            "body-class": "justify-content-center",
            "body-style": "font-size: .8725rem;"
          }),
          _createVNode(_component_Column, {
            field: "referral_approved_at",
            header: "Date of Approval",
            "header-class": "justify-content-center",
            "body-class": "justify-content-center",
            "body-style": "font-size: .8725rem;"
          })
        ]),
        _: 1
      }, 8, ["value", "loading"])
    ]),
    _: 1
  }))
}
}

})